import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import I18n from 'I18n';
import { getCurrentUser, getHasEditAllScope, getHasEditOwnedScope, getHasEditTeamScope, getUserPrimaryTeam } from '../../../selectors/authSelectors';
import { getPipelineFilter } from '../../../selectors/filtersSelectors';
import { getTeamsMap } from '../../../selectors/usersSelectors';
import { getOwnerIdToUserIdMap, getOwnersMap } from '../../../selectors/ownersSelectors';
import { canUserSubmitForecast } from '../../../utils/permissionsHelper';
export const useSubmitForecastDisabledTooltipTitle = () => {
  const currentUser = useSelector(getCurrentUser);
  const hasEditAllScope = useSelector(getHasEditAllScope);
  const hasEditOwnedScope = useSelector(getHasEditOwnedScope);
  const hasEditTeamScope = useSelector(getHasEditTeamScope);
  const selectedPipelines = useSelector(getPipelineFilter);
  const teams = useSelector(getTeamsMap);
  const userPrimaryTeam = useSelector(getUserPrimaryTeam);
  const owners = useSelector(getOwnersMap);
  const ownerIdToUserIdMap = useSelector(getOwnerIdToUserIdMap);
  const {
    ownerId
  } = useParams();
  const owner = owners.get(ownerIdToUserIdMap.get(Number(ownerId)));
  const ownerUserId = owner === null || owner === void 0 ? void 0 : owner.get('userIdIncludingInactive');
  if (!selectedPipelines.size) {
    return I18n.text('repDetail.disabledTooltip.multipipeline');
  }
  const hasPermissionToSubmit = canUserSubmitForecast({
    canEditAll: hasEditAllScope,
    canEditOwned: hasEditOwnedScope,
    canEditTeam: hasEditTeamScope,
    currentUserId: currentUser.user_id,
    isUser: true,
    primaryTeam: userPrimaryTeam,
    targetEditId: ownerUserId,
    teams
  });
  if (hasPermissionToSubmit) {
    return null;
  }
  return I18n.text('repDetail.disabledTooltip.permissions');
};